import React, { createContext, useState, useEffect } from 'react';

const getLocalUser = () => {
  try {
    const data = localStorage.getItem("WLF_Mobile_admin_ID");
    return data ? JSON.parse(data) : null;
  } catch (err) {
    localStorage.removeItem("WLF_Mobile_admin_ID");
    return null;
  }
};

// const getCookie = (name) => {
//   const match = document.cookie.match(
//     new RegExp("(^| )" + name + "=([^;]+)")
//   );

//   const inputCookie = match?.input;

//   const cookieResult = inputCookie
//     ? inputCookie
//       .split("; ")
//       .filter(c => c.startsWith("WLF_Mobile_admin_token="))
//       .pop()
//       ?.split("=")[1] || ""
//     : "";
//   return cookieResult;
// };


function getCookie(name) {
  const cookieValue = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
  return cookieValue ? cookieValue.pop() : '';
}

export const AuthContext = createContext('');

const AuthProvider = ({ children }) => {
  const [authId, setAuthId] = useState(getLocalUser());
  const [authUser, setAuthUser] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [token, setToken] = useState(getCookie('WLF_Mobile_admin_token'));

  const setAuthCredential = ({ adminData, token }) => {
    setAuthId(adminData);
    setToken(token);
  }



  // useEffect(() => {
  //   // if (!authId?._id) {
  //   //   SignOut();
  //   //   setLoading(false);
  //   //   return;
  //   // }

  //   const fetchUser = async () => {
  //     try {
  //       const res = await fetch(
  //         `https://api.wlfmobile.com/api/admin/role/view/${authId?._id}`,

  //       );

  //       const data = await res.json();
  //       if (data?.success) {
  //         setAuthUser(data?.data);
  //       } else {
  //         SignOut();
  //       }
  //     } catch (err) {
  //       // console.log(err)
  //       if (err) {
  //         SignOut();
  //       }
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchUser();
  // }, [authId, token]);


    useEffect(() => {
    if (authId?._id) {
      fetch(`https://api.wlfmobile.com/api/admin/role/view/${authId?._id}`, {
        method: "GET",
      })
        .then((res) => res.json())
        .then((data) => {
          if (data?.success) {
            setAuthUser(data?.data);
          } else {
            SignOut();
          }
          setLoading(false);
        });
    } else {
      SignOut();
      setLoading(false);
      return;
    }
  }, [authId]);

  const SignOut = () => {
    document.cookie = `WLF_Mobile_admin_token=; expires=${new Date(
      0
    ).toUTCString()};  path=/`;
    localStorage.removeItem("WLF_Mobile_admin_ID");
    setAuthCredential({ adminData: null, token: null });
  };


  const authInfo = { authUser, setAuthCredential, isLoading, setLoading, setAuthUser, token, authId, SignOut };
  if (isLoading) {
    return <></>;
  }
  return (
    <AuthContext.Provider value={authInfo}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;